import SortConstants from '../constants/SortConstants';

export const SORT_PARAM_KEY = 'sort';

const VALID_SORT_METHODS = new Set(Object.values(SortConstants.SORT_METHOD));

export function sortToParam(sortMethod) {
    if (!sortMethod) return {};
    return { [SORT_PARAM_KEY]: sortMethod };
}

export function paramToSort(searchParams) {
    const sort = searchParams.get(SORT_PARAM_KEY);
    if (sort !== null && VALID_SORT_METHODS.has(sort)) {
        return sort;
    }
    return null;
}
